import { Strong, Toggle } from '@ahmdigital/ui';
import styled from 'styled-components';

type HeaderWrapperProps = {
  isProductPage: boolean;
};

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  background-color: ${({ theme }) => theme.colors.black};
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
  ${({ isProductPage }) =>
    isProductPage &&
    `
      gap: 0.5rem;
      padding: 0.5rem 2rem 1rem 2rem;
    `}
`;

export const LargeDevicePremiumReviewToggleWrapper = styled.div`
  margin-bottom: -3rem;
  margin-left: -1.5rem;
  width: calc(100% + 3rem);
`;

export const StyledDiv = styled.div`
  margin: 0 auto;
`;

export const StyledStrong = styled(Strong)`
  display: inline-block;
`;

export const StyledToggle = styled(Toggle)`
  margin-bottom: unset;
`;
